module.exports = __webpack_public_path__ + "media/images/design/images/btn_volunteer-0b567573fa363e9b80c8c491084b09a4.png";